import { Edition } from '@atlassian/touchpoint-commons-event-analytics';

import type { DialogConfig } from '../shared/types';

export const DIALOG_CONFIG: DialogConfig = {
	touchpointIntent: 'startTrial',
	dialogId: 'free-to-standard-refresh-modal',
	dialogType: 'modal',
	targetProductEdition: Edition.STANDARD_EDITION,
};
